export default __webpack_public_path__ + "static/illustration-periodic-table-f14c5381a66e7b214d1b9067b2cc3a1c.svg";